// src/components/layout/AppLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import HeaderAuth from "../home/HeaderAuth";
import HeaderNonAuth from "../home/HeaderNonAuth";

export default function AppLayout() {
  const { isAuthenticated, loading } = useAuth();

  // Hold render until context hydrates from localStorage
  // Prevents wrong header flashing on first load
  if (loading) return null;

  return (
    <>
      {isAuthenticated ? <HeaderAuth /> : <HeaderNonAuth />}
      <Outlet />
    </>
  );
}